import { CircularProgress } from "@mui/material";
import styles from "./style.module.scss"
import React from "react";

function CircularLoader() {
  return <CircularProgress color="inherit" className={styles.loader} />;
}

export default CircularLoader;
